import {throttle} from "lodash";
import {nextTick} from "vue";
import _u from '../shared/utils';
import Dropdown from "./dropdown";

const floatingTooltip = {
    extends: Dropdown,
    template: '#floating-tooltip',

    props: {
        preferredOrientation: {
            type: Array,
            required: false,
        },
        staticClasses: {
            type: Array,
            required: false,
        },
    },

    data() {
        return {
            orientation: null,
            _preferredOrientation: this.preferredOrientation,
            _fallbackOrientation: 'right',
        };
    },

    watch: {
        isOpen(value) {
            if (value) {
                this._initDynamicOrientation();
            } else {
                this._stopDynamicOrientation();
            }
        },
    },

    computed: {
        classes() {
            return [...this._getDynamicClasses(), ...(this.staticClasses || [])];
        },

        floatingWidth() {
            const floatingRect = this.$refs.floating.getBoundingClientRect();
            return floatingRect.right - floatingRect.left;
        },
    },

    methods: {
        _adjustOrientation() {
            for (const orientation of this._preferredOrientation) {
                if (this._canBeOriented(orientation)) {
                    return this._setOrientation(orientation);
                }
            }

            this._setOrientation(this._fallbackOrientation);
        },

        _setOrientation(orientation) {
            this.orientation = orientation;
        },

        _canBeOriented(orientation) {
            const triggerRect = this._getTriggerRect();
            const floatingWidth = this.floatingWidth;
            const viewportWidth = this._getViewportWidth();

            switch (orientation) {
            case 'right': return triggerRect.right + floatingWidth <= viewportWidth;
            case 'left': return triggerRect.left - floatingWidth >= 0;
            default: throw new Error(`Unhandled orientation: ${orientation}`);
            }
        },

        _getTriggerRect() {
            return this.$refs.trigger.getBoundingClientRect();
        },

        _getViewportWidth() {
            return window.innerWidth;
        },

        _getDynamicClasses() {
            switch (this.orientation) {
            case 'right': return ['statistics-page__right-tooltip'];
            case 'left': return ['statistics-page__left-tooltip'];
            default: return [];
            }
        },

        _init() {
            this._id = _u.genUid();

            if (!this._preferredOrientation) {
                this._preferredOrientation = ['right', 'left'];
            }
        },

        _initDynamicOrientation() {
            this.resizeCallback = throttle(() => {
                this._adjustOrientation();
            }, 100);

            window.addEventListener('resize', this.resizeCallback);

            nextTick(() => {
                this._adjustOrientation();
            });
        },

        _stopDynamicOrientation() {
            window.removeEventListener('resize', this.resizeCallback);
        },
    },

    mounted() {
        this._init();
    },
};

export default floatingTooltip;
